export enum DynamicCartTemplateModules {
  EMPTY_CART = 'empty_cart',
  VALID_CART = 'valid_cart',
}
